import { useState, useEffect } from "react";

function RSVPListByGroup({ setCurrentResponseID }) {

    const [responses, setResponses] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const [loadingError, setLoadingError] = useState(false);

    useEffect(() => {
        fetchData();
    }, []);

    async function fetchData() {
        try {
            const res = await fetch(
                `https://wedding-website-backend-nu.vercel.app/api/responses`
            );

            if (!res.ok) {
                throw new Error(`HTTP error! status: ${res.status}`);
            }

            const data = await res.json();
            setResponses(data.responses);
        } catch (err) {
            console.error(err);
            setLoadingError(true);
        } finally {
            setPageLoading(false);
        }
    }

    const renderResponse = (bool) => {
        if (bool === true) return "Yes";
        if (bool === false) return "No";
        return "";
    }

    return (
        <div className="text-center rounded border p-2">
            <div className="subheading text-bronze mb-6 text-2xl">RSVP Groups</div>
            {pageLoading && <p>Loading...</p>}
            {loadingError && <p className="text-red-400">Failed to fetch RSVPs</p>}
            {!pageLoading && !loadingError && (
                <div className="space-y-2">
                    <ul>
                        <li className="border px-2 bg-bronze text-white">
                            <div className="flex items-center w-full p-1">
                                <div className="flex-1">
                                    <div className={`flex items-center text-xs py-1 w-full`}>
                                        <div className="flex-[2_2_0%] px-1">Guest Name</div>
                                        <div className="flex-1 px-1">Attending the Welcome Party?</div>
                                        <div className="flex-1 px-1">Attending the Wedding?</div>
                                        <div className="flex-1 px-1">Entree</div>
                                        <div className="flex-1 px-1">Age Group</div>
                                        <div className="flex-[3_3_0%] px-1">Dietary Restrictions</div>
                                    </div>
                                </div>
                                <button className="invisible ml-4 px-3 py-1 text-xs font-medium">
                                    More Info
                                </button>
                            </div>
                        </li>
                    </ul>
                    <ul className="scroll-box space-y-2 max-h-96 overflow-y-auto">
                        {responses.map((response) => (
                            <li key={response._id} className="border p-2">
                                <div className="flex items-center w-full p-1">
                                    <div className="flex-1">
                                        {response.guests.map((guest, index) => (
                                            <div
                                                key={guest.id}
                                                className={`flex text-xs py-1 w-full `}
                                            >
                                                <div className="flex-[2_2_0%] px-1">{guest.name}</div>
                                                <div className="flex-1 px-1">{renderResponse(guest.attend_welcome_party)}</div>
                                                <div className="flex-1 px-1">{renderResponse(guest.attend_wedding)}</div>
                                                <div className="flex-1 px-1">{guest.wedding_entree}</div>
                                                <div className="flex-1 px-1">{guest.age_group}</div>
                                                <div className="flex-[3_3_0%] px-1 whitespace-nowrap overflow-hidden text-ellipsis">
                                                    {guest.dietary_restrictions}
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    <button
                                        className="ml-4 px-3 py-1 text-xs font-medium text-white bg-rose hover:bg-blush hover:text-customGray"
                                        onClick={() => { setCurrentResponseID(response._id) }}
                                    >
                                        History
                                    </button>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    )
}

export default RSVPListByGroup